import React, { useState } from "react";

function Category() {
  const initialCategory = [
    {
      image: "https://img.freepik.com/free-photo/cupcakes_74190-18.jpg?w=360&t=st=1701450917~exp=1701451517~hmac=e68bffa8e1a755bab76824bc29c42b1e93cb2cd1843e5d2941f97369ac855199",
      name: "Pastry",
      price: "Rs:80",
    },
    {
      image: "https://img.freepik.com/free-photo/front-view-red-cake-slice-fruit-cake-piece-inside-plate-with-fresh-strawberries-grey_140725-20811.jpg?w=996&t=st=1701450959~exp=1701451559~hmac=ccba95bad5c8d45c1efbe38ecd86d37bfc026767785423bdfea0d7233f880884",
      name: "Red Velvet Cake",
      price: "1 Pound Rs:1000",
    },
    {
      image: "https://img.freepik.com/free-photo/front-close-view-fresh-yellow-sliced-cheese-blue-plate-old-newspaper-black-background_140725-94477.jpg?w=996&t=st=1701451010~exp=1701451610~hmac=7e3e61348d7ba73aaad130aa4b0906b853aa13de30d79251cf042c63e81fdd84",
      name: "Mango Cake ",
      price: "1 Pound Rs:700",
    },
    {
      image: "https://img.freepik.com/free-photo/ice-cream-mango-cake_1203-8828.jpg?w=996&t=st=1701451043~exp=1701451643~hmac=7a017e8e708af6ab61bf99d7e9d25efe914db25691f01ba467c0846e0faef0d1",
      name: "Pineapple Cake",
      price: "1 Pound Rs:700",
    },
    {
      image: "https://img.freepik.com/free-photo/chocolate-cake-with-dried-fruit_144627-9029.jpg?w=996&t=st=1701451076~exp=1701451676~hmac=a0ef59bae137ab52f07c1c539faf44e580d051f58914fbe783acbf32aee11ed2",
      name: "Choccolate Cake",
      price: "1Pound Rs:700",
    },
    {
      image: "https://img.freepik.com/free-photo/from-strawberry-cake-with-strawberry-tray_176474-2658.jpg?w=740&t=st=1701451110~exp=1701451710~hmac=eb092a28d72608bb84683fd7b3e8c1b37b59dbeb02d5842503e705c2ab112a48",
      name: "Black Forest",
      price: "1 Pound Rs:600",
    },
  ];

  const [category] = useState(initialCategory);
  const [showMore, setShowMore] = useState(false);

  const categoryToShow = showMore ? category : category.slice(0, 8);



  return (
    <div className="container mt-10">
      <div className="flex mx-4 md:mx-auto text-center place-content-center">
        <div className="border-b-4 border-amber-400 h-4 w-10 sm:w-16 flex items-center justify-center ml-2 sm:ml-5"></div>

        <p className="text-center text-xl sm:text-2xl text-amber-600 font-bold mb-2 font-nav">Menu</p>
        <div className="border-b-4 border-amber-400 h-4 w-10 sm:w-16 flex items-center justify-center ml-2 sm:ml-5"></div>
      </div>

      <p className="text-center font-bold font-roboto text-3xl sm:text-4xl mb-4">Most Popular items</p>

      

      {/* Show More button for screens below small */}
      <div className="md:hidden">

     
      {/* {category.length > 3 && (
        <div className="text-center mt-4 sm:hidden">
          <button
            onClick={() => setShowMore(!showMore)}
            className="bg-orange-300 w-60 text-white p-2 rounded-md backdrop-blur-sm backdrop-opacity-75 transition duration-300 ease-in-out hover:backdrop-opacity-100"
          >
            {showMore ? 'Show Less' : 'Show More'}
          </button>
        </div>
      )} */}
       </div>

       <section class="text-gray-600 body-font md:mx-36">
  <div class="container px-5 py-5 mx-auto">
    
    <div class="flex flex-wrap -m-2">
    {categoryToShow.map((item, index) => (

    
      
      <div class="p-2 lg:w-1/3 md:w-1/2 w-full">

        <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
          <img alt="team" class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4" src={item.image}/>
          <div class="flex-grow">
            <h2 class="text-gray-900 title-font font-heading font-bold">{item.name}</h2>
            <p class="text-gray-500 font-heading">{item.price}</p>
          </div>
        </div>
      </div>
            ))}

    </div>
  </div>
</section>
    </div>
  );
}

export default Category;


















